module.exports = __webpack_public_path__ + "img/vz-styling-icons-social-facebook-copy.724822fa.svg";